import { formatNumber, numberWithCommas } from "../../utils";
import { ExpressDataSummary } from "../../types/express-data.type";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

interface ExpressDataSummaryCardsProps {
  summary: ExpressDataSummary;
}

export default function ExpressDataSummaryCards({
  summary,
}: ExpressDataSummaryCardsProps) {
  const cards = [
    {
      label: "จำนวนรายการทั้งหมด",
      value: numberWithCommas(summary.totalTransactions),
    },
    {
      label: "มูลค่าสุทธิรวม",
      value: formatNumber(summary.totalNetValue, { decimals: 2 }),
    },
  ];

  return (
    <Grid
      container
      spacing={2}
      sx={{ width: "100%", justifyContent: "flex-end" }}
    >
      {cards.map((card) => (
        <Grid key={card.label} size={5.5}>
          <Box
            sx={{
              border: (theme) => `1px solid ${theme.palette.primary.main}`,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              boxShadow: "none",
              borderRadius: "12px",
              p: 2,
            }}
          >
            <Typography variant="subtitle1">{card.label}</Typography>
            <Typography
              variant="h5"
              fontWeight={600}
              sx={{ color: (theme) => theme.palette.primary.main }}
            >
              {card.value}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
